import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Form, Button, Card, Alert, Spinner } from 'react-bootstrap';

import incident_manager from '../api/incident'

const IncidentCommentForm = () => {
    const { token } = useParams()

    const [incident, setIncident] = useState(null);
    const [comment, setComment] = useState('');
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(true);
    const [fetchError, setFetchError] = useState(false);

    const raceName = (incident?.race_name || '') + (incident?.stage_index ? ` - Stage ${incident?.stage_index}` : '');

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const result = await incident_manager.post_rider_incident_comment(token, comment);
        if (result) {
            setStatus('success');
            setComment('');
        } else {
            setStatus('error');
        }
    };

    useEffect(() => {
        if (!token) window.location.href = '/unauthorized'

        const fetch = async () => {
            const response = await incident_manager.get_incident_from_token(token);
            if (response) {
                setIncident(response)
                setFetchError(false);
            } else {
                setFetchError(true);
            }

            setLoading(false);
        }
        fetch();
    }, [token])

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <Card style={{ width: '100%', maxWidth: '600px' }}>
                <Card.Body>
                    <Card.Title className="text-center mb-4">Incident Comment</Card.Title>

                    {loading && (
                        <div className="d-flex justify-content-center py-5">
                            <Spinner animation="border" role="status" />
                        </div>
                    )}


                    {fetchError && !loading && (
                        <Alert variant="danger">
                            ❌ Unable to load incident data. The token may be invalid, previously used or expired.
                        </Alert>
                    )}

                    {!loading && incident && (
                        <>
                            {status === 'success' && (
                                <Alert variant="success" onClose={() => setStatus(null)} dismissible>
                                    ✅ Comment submitted successfully.
                                </Alert>
                            )}

                            {status === 'error' && (
                                <Alert variant="danger" onClose={() => setStatus(null)} dismissible>
                                ❌ Failed to submit comment. Please try again.
                                </Alert>
                            )}

                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="raceName" className="mb-3">
                                    <Form.Label>Race Name</Form.Label>
                                    <Form.Control type="text" readOnly value={raceName} />
                                </Form.Group>
                                <Form.Group controlId="incidentDescription" className="mb-3">
                                    <Form.Label>Incident Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        value={incident?.incident_summary}
                                        style={{
                                            backgroundColor: '#e9ecef',
                                            color: '#6c757d',
                                            borderColor: '#ced4da'
                                        }}
                                    />
                                </Form.Group>
                                <Form.Group controlId="incidentDistance" className="mb-3">
                                    <Form.Label>Distance to Finish (km)</Form.Label>
                                    <Form.Control type="text" readOnly value={incident?.incident_km_from_finish} />
                                </Form.Group>
                                <Form.Group controlId="incidentDate" className="mb-3">
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control type="text" readOnly value={formatDate(incident?.incident_timestamp)} />
                                </Form.Group>
                                <Form.Group controlId="ridersInvolved" className="mb-3">
                                    <Form.Label>Amount of Riders Involved</Form.Label>
                                    <Form.Control type="text" readOnly value={incident?.incident_number_of_riders} />
                                </Form.Group>
                                <Form.Group controlId="userComment" className="mb-3">
                                    <Form.Label>Your Comment</Form.Label>
                                    <Form.Text className="text-muted fst-italic d-block mb-2">
                                        Please describe what happened during the crash, any causes you identified or observed, and any improvements you believe could help prevent similar incidents.
                                    </Form.Text>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        placeholder="Write your comment here..."
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                    />
                                </Form.Group>
                                <Button variant="primary" type="submit" className="w-100">Submit Comment</Button>
                            </Form>
                        </>
                    )}
                </Card.Body>
            </Card>
        </Container>
    );
}

export default IncidentCommentForm;